import { Redirect } from 'react-router-dom'

export const LoginPage = () => <Redirect to="/?view=login" />
